import deepmerge from '@mui/utils/deepmerge';
import createTheme from './createTheme';
export default function createMuiStrictModeTheme(options, ...args) {
  return createTheme(deepmerge({
    unstable_strictMode: true
  }, options), ...args);
}


//////////////////
// WEBPACK FOOTER
// ../@mui/material/styles/createMuiStrictModeTheme.js
// module id = 1776
// module chunks = 25